import React, { memo, useEffect, useRef } from 'react';
function FetchMoreContainerComponent(props) {
    const { children, onReachBottom, disabled } = props;
    const containerRef = useRef(null);
    const isFetchingRef = useRef(false);
    useEffect(()=>{
        var _containerRef_current;
        const scrollTarget = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.firstElementChild;
        if (!(scrollTarget instanceof HTMLElement)) return;
        const handleScroll = async ()=>{
            if (disabled || isFetchingRef.current) return;
            const distanceFromBottom = scrollTarget.scrollHeight - scrollTarget.scrollTop - scrollTarget.clientHeight;
            const fetchMoreThresholdPx = 200;
            if (distanceFromBottom < fetchMoreThresholdPx) {
                isFetchingRef.current = true;
                await onReachBottom();
                isFetchingRef.current = false;
            }
        };
        scrollTarget.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>scrollTarget.removeEventListener('scroll', handleScroll);
    }, [
        disabled,
        onReachBottom
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        style: {
            display: 'contents'
        }
    }, children);
}
export const FetchMoreContainer = /*#__PURE__*/ memo(FetchMoreContainerComponent);
